import { Directive, HostListener, Input } from "@angular/core";
import { HelpSection } from "ng/src/app/core/help-section";

@Directive({
	selector: '[helpLink]'
})
export class HelpLinkDirective {
	@Input('helpLink') section!: string;
	
	constructor() {}
	
	@HostListener('click')
	onClick() {
		HelpSection.openHelp(this.section);
	}
}